import type * as Types from '../../../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetScheduleAddToCalendarOverridesQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GetScheduleAddToCalendarOverridesQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    info: {
      __typename?: 'EventInfo';
      id: string;
      schedule: { __typename?: 'EventScheduleInfo'; id: string; items: Array<{ __typename?: 'EventSchedule'; id: string; name: string; showAddToCalendar?: boolean | null }> };
    };
  } | null;
};

export const GetScheduleAddToCalendarOverridesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetScheduleAddToCalendarOverrides' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'BooleanValue', value: true } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'schedule' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'items' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'showAddToCalendar' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetScheduleAddToCalendarOverridesQuery__
 *
 * To run a query within a React component, call `useGetScheduleAddToCalendarOverridesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduleAddToCalendarOverridesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduleAddToCalendarOverridesQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetScheduleAddToCalendarOverridesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetScheduleAddToCalendarOverridesQuery, GetScheduleAddToCalendarOverridesQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetScheduleAddToCalendarOverridesQuery, GetScheduleAddToCalendarOverridesQueryVariables>(GetScheduleAddToCalendarOverridesDocument, baseOptions);
}
export function useGetScheduleAddToCalendarOverridesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetScheduleAddToCalendarOverridesQuery, GetScheduleAddToCalendarOverridesQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetScheduleAddToCalendarOverridesQuery, GetScheduleAddToCalendarOverridesQueryVariables>(
    GetScheduleAddToCalendarOverridesDocument,
    baseOptions,
  );
}
export type GetScheduleAddToCalendarOverridesQueryHookResult = ReturnType<typeof useGetScheduleAddToCalendarOverridesQuery>;
export type GetScheduleAddToCalendarOverridesLazyQueryHookResult = ReturnType<typeof useGetScheduleAddToCalendarOverridesLazyQuery>;
export type GetScheduleAddToCalendarOverridesQueryResult = Apollo.QueryResult<GetScheduleAddToCalendarOverridesQuery, GetScheduleAddToCalendarOverridesQueryVariables>;
